export type BlockOutDayDoW = BlockOutDay["dayOfWeek"];

/**
 * A mapping between the integers used to represent the days of the week by
 * a JS Date object and the string keys used to represent the blocked out
 * day of the week on a block-out day. In hindsight, I probably should have
 * stored the block-out days as integers... :/
 */
export const BlockOutDayDoWToJSDateDoW: Record<BlockOutDayDoW, number> = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
} as const;

export type BlockOutDay = {
  key: string;
  dayOfWeek: "MONDAY" | "TUESDAY" | "WEDNESDAY" | "THURSDAY" | "FRIDAY" | "SATURDAY" | "SUNDAY";
  meridiem: "AM" | "PM" | null;
};
